import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { createFileRoute, redirect, useSearch } from "@tanstack/react-router";

import { ScreenSpinner } from "@/components";
import { analytics } from "@/config/analytics";
import { CART_ORIGIN } from "@/constants";
import { SELLING_PLANS, VARIANT_IDS } from "@/domains/surveys/models/constants";
import { postPurchaseSubscribeSearchSchema } from "@/domains/surveys/models/schemas";
import { usePostPurchaseSurveyParams } from "@/domains/surveys/queries/use-post-purchase-survey-params";
import { Button, Card, Heading } from "@/ui";
import { buildAddToCartCartUrl } from "@/utils/shopify";
import { ContactBar } from "./-components";

const PostPurchaseSubscribe = () => {
  const { order_id } = useSearch({ from: "/_guest/post-purchase/subscribe/" });
  const { surveyParams } = usePostPurchaseSurveyParams(order_id);

  if (!surveyParams) {
    return <ScreenSpinner />;
  }

  return (
    <div className="flex flex-col items-center gap-7 px-4 py-8 sm:px-6 md:gap-14 md:py-20">
      <div className="flex max-w-4xl flex-col gap-7 md:gap-14">
        <Card className="flex flex-col">
          <ContactBar />
          <div className="flex flex-col gap-6 px-6 py-7 md:gap-8 md:px-14 md:py-12">
            <div className="flex flex-col-reverse items-center gap-8 md:flex-row">
              <img
                alt={surveyParams.flowProduct.name}
                className="w-72 rounded-lg"
                src={surveyParams.flowProduct.image}
              />
              <div className="flex flex-1 flex-col gap-6">
                <Heading className="text-center md:text-left" level={2}>
                  Great! Now it&apos;s time to save.
                </Heading>
                <p>
                  Since things are going well, we&apos;d like to invite you to subscribe. Your
                  inhaler will be sent to you automatically. You can cancel any time.{" "}
                  <span className="font-semibold">
                    And you&apos;ll enjoy a 10% discount. Today, tomorrow and forever.
                  </span>
                </p>
              </div>
            </div>
            <Button asChild>
              <a
                className="flex w-full items-center justify-center"
                href={buildAddToCartCartUrl({
                  variantId: VARIANT_IDS.GUIDED_RAPID_RELIEF,
                  sellingPlan: SELLING_PLANS.ONE_MONTH_SUB,
                  attributes: {
                    origin: CART_ORIGIN.POST_PURCHASE,
                  },
                })}
                onClick={() => {
                  return analytics.track("post_purchase_subscribe_started");
                }}
                rel="noreferrer"
                target="_blank"
              >
                <span>Subscribe Now</span>
                <ArrowRightIcon className="h-5" />
              </a>
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_guest/post-purchase/subscribe/")({
  component: PostPurchaseSubscribe,
  validateSearch: postPurchaseSubscribeSearchSchema,
  onError: (error) => {
    if (error.routerCode === "VALIDATE_SEARCH") {
      throw redirect({ to: "/" });
    }
  },
});
